<div class="header-bar" *ngIf="viewInit">
  <div class="header-left"></div>
  <div class="header-center">
    {{ isNewAudience ? "Create Audience" : "Edit Audience" }}
  </div>
  <div class="header-right">
    <button
      *ngIf="!isNewAudience"
      mat-button
      color="lightGreen"
      [disabled]="saveDisabled"
      (click)="saveAudience()"
    >
      Save Audience
    </button>
    <button
      *ngIf="isNewAudience"
      mat-button
      color="lightGreen"
      [disabled]="saveDisabled"
      (click)="createAudience()"
    >
      Create Audience
    </button>
  </div>
</div>

<div class="audience">
  <lhpe-audience-container></lhpe-audience-container>
</div>
